
/** Aide gestion des dates */
const dateService = {
	//difference en mois entre 2 dates
	diffInMonths(date1: Date, date2: Date) {
		var months;
		months = (date2.getFullYear() - date1.getFullYear()) * 12;
		months -= date1.getMonth();
		months += date2.getMonth();
		if (date1.getDate()>date2.getDate()) {
			months--;
		}
		return months <= 0 ? 0 : months;
	}
};

export default dateService;